import React from 'react';
import CalendarComponent from "../../components/Calendar/Components/CalendarComponent";

export const Calendar = () => {
    return (
        <div>
            <CalendarComponent/>
        </div>
    );
};